import { config } from '../config';
import { downloadCSVFile, generateQueryString, isValidUUID, makeApiRequest_AppJson, makeApiRequest_formData } from './common-apiService';

export const fetchGitIndicatorsData = async () => {
    const url = `${config.baseB2B_URL}/b2b/indicators/git`;
    const headers = {
        'X-B2B-API-Key': config.gitAPIKey,
    };
    return makeApiRequest_AppJson(url, 'GET', headers);
};

export const fetchCustomIndicatorsData = async (page, pageSize, searchFields, accessToken) => {
    const url = `${config.baseB2B_URL}/b2b/indicators/custom/paged?page=${page}&size=${pageSize}&${generateQueryString(searchFields)}&plansUsage=true&genericFwUsage=true`;
    const headers = {
        Authorization: `Bearer ${accessToken}`,
    };
    return makeApiRequest_AppJson(url, 'GET', headers);
}

// QUANTITATIVE INDICATORS

export const saveNewQuantitativeIndicator = async (indicator, accessToken) => {
    const url = `${config.baseB2B_URL}/b2b/indicators/quantitative/new`;
    const headers = {
        Authorization: `Bearer ${accessToken}`,
    };
    return makeApiRequest_AppJson(url, 'POST', headers, indicator);
}

export const updateQuantitativeIndicator = async (indicator, accessToken) => {
    const url = `${config.baseB2B_URL}/b2b/indicators/quantitative/update`;
    const headers = {
        Authorization: `Bearer ${accessToken}`,
    };
    return makeApiRequest_AppJson(url, 'PUT', headers, indicator);
}

export const deleteQuantitativeIndicator = async (indicatorUUID, accessToken) => {
    const url = `${config.baseB2B_URL}/b2b/indicators/quantitative/delete/${indicatorUUID}`;
    const headers = {
        Authorization: `Bearer ${accessToken}`,
    };
    return makeApiRequest_AppJson(url, 'DELETE', headers);
}

// QUANT DIMENSIONAL INDICATORS

export const saveNewQuantitativeDimensionalIndicator = async (indicator, accessToken) => {
    const url = `${config.baseB2B_URL}/b2b/indicators/quantitative/dimensional/new`;
    const headers = {
        Authorization: `Bearer ${accessToken}`,
    };
    return makeApiRequest_AppJson(url, 'POST', headers, indicator);
}

export const updateQuantitativeDimensionalIndicator = async (indicator, accessToken) => {
    const url = `${config.baseB2B_URL}/b2b/indicators/quantitative/dimensional/update`;
    const headers = {
        Authorization: `Bearer ${accessToken}`,
    };
    return makeApiRequest_AppJson(url, 'PUT', headers, indicator);
}

export const deleteQuantitativeDimensionalIndicator = async (indicatorUUID, accessToken) => {
    const url = `${config.baseB2B_URL}/b2b/indicators/quantitative/dimensional/delete/${indicatorUUID}`;
    const headers = {
        Authorization: `Bearer ${accessToken}`,
    };
    return makeApiRequest_AppJson(url, 'DELETE', headers);
}

// QUALITATIVE INDICATORS

export const saveNewQualitativeIndicator = async (indicator, accessToken) => {
    const url = `${config.baseB2B_URL}/b2b/indicators/qualitative/new`;
    const headers = {
        Authorization: `Bearer ${accessToken}`,
    };
    return makeApiRequest_AppJson(url, 'POST', headers, indicator);
}

export const updateQualitativeIndicator = async (indicator, accessToken) => {
    const url = `${config.baseB2B_URL}/b2b/indicators/qualitative/update`;
    const headers = {
        Authorization: `Bearer ${accessToken}`,
    };
    return makeApiRequest_AppJson(url, 'PUT', headers, indicator);
}

export const deleteQualitativeIndicator = async (indicatorUUID, accessToken) => {
    const url = `${config.baseB2B_URL}/b2b/indicators/qualitative/delete/${indicatorUUID}`;
    const headers = {
        Authorization: `Bearer ${accessToken}`,
    };
    return makeApiRequest_AppJson(url, 'DELETE', headers);
}

// MEASUREMENT UNITS

export const fetchMeasurementUnitsData = async (accessToken) => {
    const url = `${config.baseB2B_URL}/b2b/indicators/quantitative/measurementUnits`;
    const headers = {
        Authorization: `Bearer ${accessToken}`,
    };
    return makeApiRequest_AppJson(url, 'GET', headers);
}

export const saveNewMeasurementUnit = async (measurementUnit, accessToken) => {
    const url = `${config.baseB2B_URL}/b2b/indicators/quantitative/measurementUnits/new`;
    const headers = {
        Authorization: `Bearer ${accessToken}`,
    };
    return makeApiRequest_AppJson(url, 'POST', headers, measurementUnit);
}

export const updateMeasurementUnit = async (measurementUnit, accessToken) => {
    const url = `${config.baseB2B_URL}/b2b/indicators/quantitative/measurementUnits/${measurementUnit.quantitativeMeasurementUnitId}`;
    const headers = {
        Authorization: `Bearer ${accessToken}`,
    };
    return makeApiRequest_AppJson(url, 'PUT', headers, measurementUnit);
}

export const deleteMeasurementUnit = async (measurementUnit, accessToken) => {
    const url = `${config.baseB2B_URL}/b2b/indicators/quantitative/measurementUnits/${measurementUnit.quantitativeMeasurementUnitId}`;
    const headers = {
        Authorization: `Bearer ${accessToken}`,
    };
    return makeApiRequest_AppJson(url, 'DELETE', headers);
}

export const fetchMeasurementUnit = async (quantitativeMeasurementUnitId, accessToken) => {
    const url = `${config.baseB2B_URL}/b2b/indicators/quantitative/measurementUnits/${quantitativeMeasurementUnitId}`;
    const headers = {
        Authorization: `Bearer ${accessToken}`,
    };
    return makeApiRequest_AppJson(url, 'GET', headers);
}

export const getMeasurementUnitsCSV = async (accessToken, fileName = 'filename.csv') => {
    const url = `${config.baseB2B_URL}/b2b/indicators/quantitative/measurementUnits/csv`;
    return downloadCSVFile(url, accessToken, fileName);
}

export const getMeasurementUnitsCategoriesCSV = async (accessToken, fileName = 'filename.csv') => {
    const url = `${config.baseB2B_URL}/b2b/indicators/quantitative/measurementUnits/csv/categories`;
    return downloadCSVFile(url, accessToken, fileName);
}

export const importingMeasurementUnitsCSVFile = async (file, columnSeparator = ',', accessToken) => {
    const url = `${config.baseB2B_URL}/b2b/indicators/quantitative/measurementUnits/csv?columnSeparator=${columnSeparator}`;
    const headers = {
        Authorization: `Bearer ${accessToken}`,
    };
    const formData = new FormData();
    formData.append('file', file);
    return makeApiRequest_formData(url, 'POST', headers, formData);
}

// CATEGORIES

export const fetchCategoriesData = async (accessToken) => {
    const url = `${config.baseB2B_URL}/b2b/indicators/quantitative/measurementUnits/categories`;
    const headers = {
        Authorization: `Bearer ${accessToken}`,
    };
    return makeApiRequest_AppJson(url, 'GET', headers);
}

export const saveNewCategory = async (category, accessToken) => {
    const url = `${config.baseB2B_URL}/b2b/indicators/quantitative/measurementUnits/categories/new`;
    const headers = {
        Authorization: `Bearer ${accessToken}`,
    };
    return makeApiRequest_AppJson(url, 'POST', headers, category);
}

export const updateCategory = async (category, accessToken) => {
    const url = `${config.baseB2B_URL}/b2b/indicators/quantitative/measurementUnits/categories/${category.measurementUnitCategoryId}`;
    const headers = {
        Authorization: `Bearer ${accessToken}`,
    };
    return makeApiRequest_AppJson(url, 'PUT', headers, category);
}

export const deleteCategory = async (category, accessToken) => {
    const url = `${config.baseB2B_URL}/b2b/indicators/quantitative/measurementUnits/categories/${category.measurementUnitCategoryId}`;
    const headers = {
        Authorization: `Bearer ${accessToken}`,
    };
    return makeApiRequest_AppJson(url, 'DELETE', headers);
}

export const getCategoriesCSV = async (accessToken, columnSeparator = ',', fileName = 'filename.csv') => {
    const url = `${config.baseB2B_URL}/b2b/indicators/quantitative/measurementUnits/categories/csv?columnSeparator=${columnSeparator}`;
    return downloadCSVFile(url, accessToken, fileName);
}

export const importingCategoriesCSVFile = async (file, columnSeparator = ',', accessToken) => {
    const url = `${config.baseB2B_URL}/b2b/indicators/quantitative/measurementUnits/categories/csv?columnSeparator=${columnSeparator}`;
    const headers = {
        Authorization: `Bearer ${accessToken}`,
    };
    const formData = new FormData();
    formData.append('file', file);
    return makeApiRequest_formData(url, 'POST', headers, formData);
}

// CONVERSIONS

export const saveNewConversion = async (conversion, accessToken) => {
    const url = `${config.baseB2B_URL}/b2b/indicators/quantitative/measurementUnits/conversions/new`;
    const headers = {
        Authorization: `Bearer ${accessToken}`,
    };
    return makeApiRequest_AppJson(url, 'POST', headers, conversion);
}

export const updateConversion = async (conversion, accessToken) => {
    const url = `${config.baseB2B_URL}/b2b/indicators/quantitative/measurementUnits/conversions/${conversion.from.quantitativeMeasurementUnitId}/${conversion.to.quantitativeMeasurementUnitId}`;
    const headers = {
        Authorization: `Bearer ${accessToken}`,
    };
    return makeApiRequest_AppJson(url, 'PUT', headers, conversion);
}

export const deleteConversion = async (conversion, accessToken) => {
    const url = `${config.baseB2B_URL}/b2b/indicators/quantitative/measurementUnits/conversions/${conversion.from.quantitativeMeasurementUnitId}/${conversion.to.quantitativeMeasurementUnitId}`;
    const headers = {
        Authorization: `Bearer ${accessToken}`,
    };
    return makeApiRequest_AppJson(url, 'DELETE', headers);
}

export const getConversionsCSV = async (accessToken, fileName = 'filename.csv') => {
    const url = `${config.baseB2B_URL}/b2b/indicators/quantitative/measurementUnits/conversions/csv`;
    return downloadCSVFile(url, accessToken, fileName);
}

// QUALITATIVE TYPES

export const fetchQualitativeTypesData = async (accessToken, fetchValues = false) => {
    const url = `${config.baseB2B_URL}/b2b/indicators/qualitative/types${fetchValues ? '?fetchValues=true' : ''}`;
    const headers = {
        Authorization: `Bearer ${accessToken}`,
    };
    return makeApiRequest_AppJson(url, 'GET', headers);
}

export const fetchQualitativeTypeData = async (qualitativeTypeId, accessToken) => {
    const url = `${config.baseB2B_URL}/b2b/indicators/qualitative/types/${qualitativeTypeId}`;
    const headers = {
        Authorization: `Bearer ${accessToken}`,
    };
    return makeApiRequest_AppJson(url, 'GET', headers);
}

export const importingQualTypesCSVFile = async (file, columnSeparator = ',', accessToken) => {
    const url = `${config.baseB2B_URL}/b2b/indicators/qualitative/types/csv?columnSeparator=${columnSeparator}`;
    const headers = {
        Authorization: `Bearer ${accessToken}`,
    };
    const formData = new FormData();
    formData.append('file', file);
    return makeApiRequest_formData(url, 'POST', headers, formData);
}

export const getQualTypesCSV = async (accessToken, columnSeparator = ',', fileName = 'filename.csv') => {
    const url = `${config.baseB2B_URL}/b2b/indicators/qualitative/types/csv?columnSeparator=${columnSeparator}`;
    return downloadCSVFile(url, accessToken, fileName);
}

export const saveNewQualitativeType = async (qualitativeType, accessToken) => {
    const url = `${config.baseB2B_URL}/b2b/indicators/qualitative/types/new`;
    const headers = {
        Authorization: `Bearer ${accessToken}`,
    };
    return makeApiRequest_AppJson(url, 'POST', headers, qualitativeType);
}

export const updateQualitativeType = async (qualitativeType, accessToken) => {
    const url = `${config.baseB2B_URL}/b2b/indicators/qualitative/types/${qualitativeType.qualitativeTypeId}`;
    const headers = {
        Authorization: `Bearer ${accessToken}`,
    };
    return makeApiRequest_AppJson(url, 'PUT', headers, qualitativeType);
}

export const deleteQualitativeType = async (qualitativeTypeId, accessToken) => {
    const url = `${config.baseB2B_URL}/b2b/indicators/qualitative/types/${qualitativeTypeId}`;
    const headers = {
        Authorization: `Bearer ${accessToken}`,
    };
    return makeApiRequest_AppJson(url, 'DELETE', headers);
}

export const updateQualitativeTypeWeightValue = async (weightedValue, accessToken) => {
    const url = `${config.baseB2B_URL}/b2b/indicators/qualitative/types/${weightedValue.qualitativeTypeId}/${weightedValue.qualitativeWeightedValueId}`;
    const headers = {
        Authorization: `Bearer ${accessToken}`,
    };
    return makeApiRequest_AppJson(url, 'PUT', headers, weightedValue);
}

export const deleteQualitativeTypeWeightValue = async (weightedValue, accessToken) => {
    const url = `${config.baseB2B_URL}/b2b/indicators/qualitative/types/${weightedValue.qualitativeTypeId}/${weightedValue.qualitativeWeightedValueId}`;
    const headers = {
        Authorization: `Bearer ${accessToken}`,
    };
    return makeApiRequest_AppJson(url, 'DELETE', headers);
}

// QUANT DIM TYPES

export const fetchQuantitativeDimensionalTypesData = async (accessToken) => {
    const url = `${config.baseB2B_URL}/b2b/indicators/quantitative/dimensional/types`;
    const headers = {
        Authorization: `Bearer ${accessToken}`,
    };
    return makeApiRequest_AppJson(url, 'GET', headers);
}